export default __webpack_public_path__ + "0552ef86affc39674d314fd96c3af9c2.svg";